import { useParams } from "react-router-dom";
import { CardDetailView } from "@/components/CardDetailView";

export function CardDetail() {
  const { id = "" } = useParams<{ id: string }>();
  const cardId = decodeURIComponent(id);
  return <CardDetailView cardId={cardId} />;
}
